import { useUserSettings } from '@/modules/settings/hooks/useUserSettings'
import type { UseAssetFormLayout } from '../types'
import { tween } from '@/utils/animation/tween'
import { ref } from 'vue'
import { Display } from '../components/display'
import Bubbletip from 'components/bubbletip'
import { prettyNumber } from '@/utils/number/format'

export const initialValueLayout = (): UseAssetFormLayout => ({
  needs: ['invested.type', 'invested'],
  component: () => {
    const settings = useUserSettings()
    const val = ref<number>(0)
    const w = tween(val, { duration: 0.5 })

    const elRef = ref()
    return (props) => {
      const state = props.state.value
      const tickerFrom = state?.asset.ledger.sharePrice.type || settings.currency.value
      const text = `Converted from ${(state?.invested.value || 0)} ${tickerFrom}`
      val.value = props.data.value.initialValue

      const formatted = prettyNumber(w.value, {
        american: true
      })

      return (
        <>
          <Display
            ref={elRef}
            title={'I Invested'}
            value={`${formatted} ${settings.currency.value}`}
          />
          <Bubbletip
            variant="white"
            size="s"
            disabled={tickerFrom === settings.currency.value}
            triggerRef={elRef}
            text={text}
            style={{ position: 'absolute' }}
          />
        </>
      )
    }
  }
})
